import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import {Paper, Select, styled} from '@material-ui/core'
import React, {useState} from 'react';
import {useFormik} from 'formik';
import * as yup from 'yup';
import axios from "axios";
import "./textField.css";
import Box from "@material-ui/core/Box";


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(3)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    }
}));

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

const formValidationSchema = yup.object({
    name: yup
        .string()
        .min(2, 'Il nome deve avere almeno due caratteri')
        .required('Nome richiesto'),
    email: yup
        .string()
        .email('Inserisci un\'email valida')
        .required('Email richiesta'),
    phone: yup
        .string()
        .required("Telefono richiesto")
        .matches(phoneRegExp, 'Numero di telefono non valido')
        .min(10, "troppo corto")
        .max(10, "troppo lungo"),
    password: yup
        .string()
        .matches(passwordRegExp, "La password deve contenere almeno un carattere Maiscolo, un numero e un carattere speciale")
        .required('Inserisci la password')
        .min(6, 'La password deve essere lunga almeno 6 caratteri'),
    address: yup
        .string()
        .required('Indirizzo richiesto'),
    homeNumber: yup
        .string()
        .required('civico richiesto'),
    cap: yup
        .string()
        .matches(/^[0-9]+$/, "Deve essere numerico")
        .required('cap obbligatorio')
        .min(5)
        .max(5, 'Il cap è composto da 5 numeri'),
    city: yup
        .string()
        .required('obbligatoria'),
    role: yup
        .string(),

});

const roles = [
    {
        value: 0,
        label: 'Cliente',
    },
    {
        value: 1,
        label: 'Venditore',
    },
    {
        value: 2,
        label: 'Manutentore',
    },
];

export default function Register(props) {
    const [ruolo, setRuolo] = useState('');
    const [error, setError] = useState('');
    const [registered, setRegistered] = useState(false);
    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            phone: '',
            password: '',
            address: '',
            homeNumber: '',
            cap: '',
            city: '',
            role: '',
        },

        validationSchema: formValidationSchema,
        onSubmit: async (values) => {
            await handleChange();
        },

    });

    const handleChange = async (event) => {
        const data = {
            Name: formik.values.name,
            Email: formik.values.email,
            Phone: formik.values.phone,
            password: formik.values.password,
            address: formik.values.address,
            homeNumber: formik.values.homeNumber,
            cap: formik.values.cap,
            city: formik.values.city,
            role: ruolo,
        };

        await axios.post('http://etpgaranzia.com:8080/garanzia/api/v1/auth/register', {
                email: data.Email,
                name: data.Name,
                phoneNumber: data.Phone,
                address: {
                    city: data.city,
                    zipCode: data.cap,
                    streetName: data.address,
                    streetNumber: data.homeNumber
                },
                password: data.password,
                type: data.role
            }
        ).catch(error => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    setError(error.response.data);
                }
            }
        )
        setRegistered(true);
    }

    if (registered) {
        return (
            <>
                <Grid container spacing={2} style={{
                    marginTop: "10%"
                }}>
                    <Grid item xs={12}>
                        <Item><Typography variant="h5" gutterBottom component="div">Grazie per aver effettuato la
                            registrazione!
                        </Typography></Item>
                    </Grid>
                    <Grid item xs={12}>
                        <Item> <Typography variant="h6" gutterBottom component="div">
                            Se la registrazione è andata a buon fine sarai in grado di effettuare il <Link
                            href={"#/login"}>login</Link>!</Typography></Item>
                    </Grid>
                </Grid>
                <Box textAlign={"center"} mt={"2%"}>
                    <Link href={"#/login"}>Clicca qui per eseguire il login</Link>
                </Box>
            </>
        );
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Container component="main" maxWidth="xs">
                <CssBaseline/>
                <Container className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Registrati
                    </Typography>
                    <Container className={classes.form}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    className='textField'
                                    autoComplete="fname"
                                    name="name"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    id="name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                    helperText={formik.touched.name && formik.errors.name}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    label="Nome e Cognome / Ragione Sociale"
                                    autoFocus
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    className='textField'
                                    variant="outlined"
                                    required
                                    fullWidth
                                    type="text"
                                    id="email"
                                    label="Email"
                                    name="email"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    className='textField'
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.password}
                                    error={formik.touched.password && Boolean(formik.errors.password)}
                                    helperText={formik.touched.password && formik.errors.password}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <TextField
                                    className='textField'
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="address"
                                    label="Indirizzo"
                                    type="text"
                                    id="address"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.address}
                                    error={formik.touched.address && Boolean(formik.errors.address)}
                                    helperText={formik.touched.address && formik.errors.address}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    className='textField'
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="homeNumber"
                                    label="Civico"
                                    id="homeNumber"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.homeNumber}
                                    error={formik.touched.homeNumber && Boolean(formik.errors.homeNumber)}
                                    helperText={formik.touched.homeNumber && formik.errors.homeNumber}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    className='textField'
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="cap"
                                    label="CAP"
                                    type="numeric"
                                    id="cap"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.cap}
                                    error={formik.touched.cap && Boolean(formik.errors.cap)}
                                    helperText={formik.touched.cap && formik.errors.cap}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    className='textField'
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="city"
                                    label="Città"
                                    type="text"
                                    id="city"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.city}
                                    error={formik.touched.city && Boolean(formik.errors.city)}
                                    helperText={formik.touched.city && formik.errors.city}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    className='textField'
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="phone"
                                    label="Telefono"
                                    type="text"
                                    id="phone"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.phone}
                                    error={formik.touched.phone && Boolean(formik.errors.phone)}
                                    helperText={formik.touched.phone && formik.errors.phone}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Select
                                    className='textField'
                                    variant="outlined"
                                    fullWidth
                                    labelId="ruolo-label"
                                    label="Ruolo"
                                    id="ruolo-select"
                                    name="role"
                                    value={ruolo}
                                    onChange={(event) => {
                                        setRuolo(event.target.value);
                                    }}
                                >
                                    {roles.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                        </Grid>
                        {error !== '' ? {error} : ''}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            Registrati
                        </Button>
                        <Grid container justify="flex-end" style={{
                            display: "flex",
                            justifyContent: "center"
                        }}>
                            <Grid item>
                                <Link href="#/login" variant="body2">
                                    Hai già un account? Login
                                </Link>
                            </Grid>
                        </Grid>
                    </Container>
                </Container>
            </Container>
        </form>
    );
}
